import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  studyList: [],
};

export const studyListSlice = createSlice({
  name: "studyList",
  initialState,
  reducers: {
    updateStudyList: (state, action) => {
      return {
        ...state,
        studyList: action.payload,
      };
    },
  },
});

export const { updateStudyList } = studyListSlice.actions;

export default studyListSlice.reducer;
